export default {
  common: {
    Unsaved_changes: 'Cambios sin guardar',
    There_are_unsaved_changes_in_this_comment: 'Este comentario tiene cambios sin guardar.',
    Continue_editing: 'Seguir editando',
    Drop_changes: 'Descartar cambios',
    Add_link: 'Añadir enlace',
    Enter_a_URL: 'Introduce una URL',
    Link_text: 'Texto',
    Enter_link_text: 'Introduce el texto a mostrar',
    Cancel: 'Cancelar',
    Add: 'Añadir',
    Executed_by_agent: 'Ejecutado por {agent}',
    Save: 'Guardar',
    Edit: 'Editar',
    Update: 'Actualizar',
    Previous: 'Anterior',
    Next: 'Siguiente',
    Loading: 'Cargando…',
    Total: 'Total',
    Details: 'Detalles',
  },
  dayoff: {
    select_title: 'Selecciona tus días libres',
    selection_hint: 'Haz clic en un día · arrastra para seleccionar un rango',
    today: 'Hoy',
    days_selected: 'día(s) seleccionado(s)',
    selected_days: 'Días seleccionados',
    legend_selected: 'Seleccionado',
    legend_your: 'Tu día libre',
    legend_holiday: 'Festivo oficial',
    legend_mate: 'Compañero ausente',
    away_this_period: 'Ausente en este período',
    nobody_away: 'Nadie está ausente en este período',
    description: 'Descripción',
    description_placeholder: 'p. ej. Vacaciones, día ocupado…',
    submit: 'Guardar días libres',
    saved: 'Días libres guardados: {range} — {count} día(s)',
    saved_empty: 'Se han eliminado todos los días libres',
    you: 'tú',
    tip_holiday: 'Festivo',
    tip_away: 'Ausente',
    tip_out_count: '1 persona fuera de la oficina | {count} personas fuera de la oficina',
    tip_more: '+{count} más',
    days_count: '1 día | {count} días',
    tip_holiday_war: 'No es día libre durante la ley marcial',
    on_dayoff_today: 'Hoy de día libre',
    gcal_title: 'Google Calendar',
    gcal_connect: 'Conectar Google Calendar',
    gcal_connected: 'Google Calendar sincronizado',
    gcal_disconnect: 'Desconectar',
    history_title: 'Historial de solicitudes',
    history_period: 'Período',
    history_days: 'Días',
    history_note: 'Nota',
    history_added: 'Añadido',
    history_empty: 'Aún no has tomado días libres',
    history_requests: '1 solicitud | {count} solicitudes',
    history_used_year: '1 día usado este año | {count} días usados este año',
    days_short: '{count}d',
    unsaved_title: 'Días libres sin guardar',
    unsaved_message: 'Los días elegidos y la nota aún no se han guardado.',
    unsaved_keep: 'Seguir editando',
    unsaved_drop: 'Descartar cambios',
    clear: 'Borrar selección',
  },
  board: {
    add_new_task: 'Añadir nueva tarea',
    add_stage: 'Añadir etapa',
    add_column: 'Añadir columna',
    enter_stage_name: 'Introduce el nombre de la etapa',
    no_stages_title: 'Todavía no hay etapas',
    no_stages_text: 'Añade tu primera etapa para empezar a crear tareas.',
    need_stage_to_create_task: 'Añade al menos una etapa a este proyecto antes de crear una tarea.',
    Enter_task_description: 'Introduce la descripción de la tarea',
    Delete_stage: 'Eliminar etapa',
    sure_delete_stage: '¿Seguro que quieres eliminar esta etapa?',
    really_delete_stage: '¿Realmente quieres eliminar la etapa',
    stage_also_leted: '¡También se eliminarán todas las tareas de la etapa!',
    CANCEL: 'CANCELAR',
    YES: 'SÍ',
    we_send_invite: 'Hemos enviado una invitación al correo:',
    please_ask_user: 'Pide al usuario que acepte el enlace para unirse a tu proyecto',
    okay: 'Vale',
  },
  comments: {
    bot_line1: '¡Bien hecho! Has abierto una tarea.',
    bot_line2: 'Como ves, tu tiempo ya se cuenta en la esquina inferior derecha',
    bot_line3:
      'Puedes escribir un nuevo mensaje aquí o arrastrar y soltar un archivo para adjuntarlo',
    max_pins_reached: 'Se permiten como máximo 5 comentarios fijados',
    pin_comment: 'Fijar comentario',
    pinned_comments: 'Comentarios fijados',
    add_reaction: 'Añadir reacción',
  },
  notifications: {
    all_caught_up: 'Estás al día',
    all_caught_up_hint: 'Aquí aparecerán menciones, invitaciones y solicitudes',
    read_all: 'Leer todo',
    added_you_to_project: 'te añadió al proyecto',
    open_project: 'Abrir proyecto',
    rejected_invite_workspace: 'rechazó la invitación a este espacio de trabajo',
    requested_to_add: 'solicitó añadir',
    for: 'para',
    Task: 'Tarea',
    task_created: 'creada',
    task_deleted: 'eliminada',
    task_transferred: 'transferida',
    task_restored: 'restaurada',
    Restore: 'Restaurar',
    image_deleted: 'Imagen eliminada',
    NEW: 'NUEVO',
    Accept: 'Aceptar',
    Reject: 'Rechazar',
    Accepted: 'Aceptado',
    Rejected: 'Rechazado',
    Viewed: 'Visto',
    Then_Deleted: 'Luego eliminado',
    Then_Canceled: 'Luego cancelado por',
    by: 'por',
    notify_assigned: 'te asignó a',
    mention_in_task: 'mención en',
    mentioned_you_in_task: 'te mencionó en la tarea',
    invoice_autogen_failed: 'No se pudo generar automáticamente la factura de {month}, plantilla',
    invoice_autogen_sent: 'La factura de {month} se envió automáticamente, plantilla',
    open_invoice_generator: 'Abrir el generador de facturas',
    to_a_task: 'a una tarea',
    new_assign: 'Te han asignado a una tarea',
    dayoff_is_off: '{name} no estará',
    user_commented: '{name} comentó',
    user_assigned_you: '{name} te asignó',
    offline_mode: 'Modo sin conexión',
    no_new_version_found: 'No se encontró ninguna versión nueva',
    your_account_deleted: 'Tu cuenta ha sido eliminada',
  },
  uploads: {
    not_uploaded: '{count} sin subir',
    queued: 'En cola',
    saving: 'Guardando',
    done: 'Listo',
    retry_attempt: 'Reintento {attempt} de {max}',
    offline: 'Esperando la red',
    failed: 'No subido',
    retry: 'Reintentar',
    remove: 'Quitar',
    errors: {
      too_large: 'Supera {limit}, no se ha subido',
      not_uploaded: 'El archivo no llegó al almacenamiento',
      storage_refused: 'El almacenamiento rechazó el archivo',
      unreachable_storage: 'No se pudo conectar con el almacenamiento',
      server_error: 'El servidor no pudo guardar el archivo',
    },
  },
  system: {
    syncing: 'Sincronizando',
    __resume_button: 'Reanudar',
    __ok_button: 'OK',
    __stop_button: 'Parar',
    __hide_button: 'Ocultar',
    __resume_last_task: 'Reanudar la última tarea',
    __create_task_notify: 'Crear tarea',
    __not_tracking_title: 'No estás registrando',
    __not_tracking_subtitle: 'en los últimos 10 minutos',
    __still_here_title: '¿Sigues ahí?',
    __still_here_subtitle: 'Sin actividad hace rato: el seguimiento se detendrá',
    __still_here_confirm: 'Estoy aquí',
    __wait_install_app: 'Espera, por favor. Instalando Tracklify...',
    __accept_button: 'Aceptar',
    __reject_button: 'Rechazar',
    __mute_tomorrow: 'Silenciar hoy',
    __muted_title: 'Recordatorios silenciados',
    __muted_subtitle: 'hasta mañana',
    __undo: 'Deshacer',
    __timer_running: 'El temporizador está en marcha',
    __approve_tracked_time: 'Aprueba el tiempo registrado',
    __no_estimate: 'Sin estimación',
    __not_tracking_label: 'Sin registrar',
    __until_tomorrow: 'Hasta mañana',
    __no_activity_detected: 'No se detectó actividad',
    __open_app: 'Abrir la app',
    __cancel: 'Cancelar',
    __you_resume_tracking: 'Has reanudado el registro en:',
    /* Main notify */
    __tracker_was_closed: 'El tracker se cerró con un registro activo',
    __tracking_resume: 'Registro reanudado',
    __new_version_found: 'Se encontró una versión nueva',
    __new_version_found_but_error:
      'Se encontró una versión nueva, pero la actualización automática no es compatible con este sistema',
    __new_version_download_button: 'Descargar',
    __later_button: 'Más tarde',
    __downloading_version: 'Descargando la nueva versión',
    __install_button: 'Instalar ahora',
    __downloading_version_percent: 'Descargando la nueva versión',
    __failed_download: 'No se pudo descargar la nueva versión',
    __try_again: 'Intentar de nuevo',
    __dismiss_button: 'Descartar',
    __installing_new_version: 'Instalando la nueva versión',
    __failed_install: 'No se pudo instalar la nueva versión',
    __failed_open_new_version:
      'No se pudo abrir la nueva versión. Cierra la aplicación y ábrela manualmente de nuevo.',
    __close_app: 'Cerrar la app',
    __tracking_stopped: 'Registro detenido: inactividad',
    __tricking_resume: 'Registro reanudado: sistema reactivado',
    __tracking_stopped_shutdown: 'Registro detenido: el PC se está apagando',
    __tricking_resume_unlocked: 'Registro reanudado: pantalla desbloqueada',
    __downloading_done: 'Descarga completada',
  },
  appRunner: {
    open_now: 'Abrir ahora',
    not_installed: 'No instalado',
    started: 'Iniciado',
    starting: 'Iniciando',
    install_app_to_track: 'Obtener la app de escritorio',
    instalattion_is_simple:
      '¡Olvídate de los diálogos de «Compartir pantalla», recibe notificaciones agradables y disfruta de la mejor experiencia con la app de escritorio de Tracklify!',
    install_desktop: 'Instala la app de escritorio de Tracklify para un registro sin interrupciones',
    authorize_app: 'Autoriza tu aplicación',
    click_to_authorize: 'Haz clic en «Abrir ahora» para abrir la app como',
    install_step1: 'Descarga la app haciendo clic en el botón de abajo',
    install_step2: 'Ejecuta el archivo descargado',
    see_other_platforms: 'Ver descargas para otras plataformas',
    install_help: 'Ayuda con la instalación',
    done_button: 'Listo',
    already_installed: '¿Ya está instalado? Puedes cerrar esta página.',
    download_app: 'Descargar la app',
    download_app_deb: 'App para Ubuntu, Mint y otros sistemas basados en Debian',
    download_app_rpm: 'App para Redhat, Fedora y otros sistemas basados en RPM',
    download_app_pacman: 'App para Arch Linux y otros sistemas basados en Arch',
    download_app_mac: 'Descargar la app para macOS (DMG)',
  },
  search: {
    search_or_navigate: 'Buscar o navegar',
    hint: 'Introduce el texto de la tarea, el nombre de un miembro,<br> una etiqueta o el nombre de un proyecto',
    nothing_found: 'No se encontró nada ¯\\_(ツ)_/¯',
    go_to: 'Ir a',
    open: 'Abrir',
    in: 'en',
    in_tasks: 'Buscar en tareas:',
    invite: 'Invitar',
    invite_to_project: 'al espacio de trabajo y al proyecto',
    invite_user: 'Invitar usuario',
    tasks_on: 'tareas sobre:',
    tasks_by: 'tareas de:',
    unassigned: 'Sin asignar',
    noTag: 'Sin etiquetas',
    clear_all: 'Borrar todo',
    clear: 'Borrar',
    tagged: 'etiquetado',
    show_all_tags: 'Mostrar todas las etiquetas',
    on: 'sobre',
    by: 'de',
    sign_up_not_confirmed: 'Registro en el espacio de trabajo no confirmado',
  },
  combobox: {
    nothing_found: 'No se encontró nada',
    create_hint: 'Pulsa Enter para añadir «{query}»',
    clear: 'Borrar',
  },
  taskFilters: {
    filter: 'Filtro',
    title: 'Filtros',
    applyFilters: 'Aplicar filtros',
    show_more: 'Mostrar más',
    hide: 'Ocultar',
    createdTime: 'Fecha de creación',
    today: 'Hoy',
    yesterday: 'Ayer',
    assignee: 'Asignado a',
    executor: 'Ejecutor',
    createdBy: 'Creado por',
    tags: 'Etiquetas',
    withTags: 'Con etiquetas',
    avgUserVelocityPerDay: 'Velocidad media del usuario por día',
    userAlreadyTrackedTimeByTag: 'Tiempo ya registrado por etiqueta',
    estimation: 'Estimación',
    inTotal: 'En total:',
  },
  projectPriorities: {
    title: 'Orden de proyectos',
    hint: 'Arrastra los proyectos para definir el orden de sus grupos en «Mis tareas». Las tareas urgentes siempre quedan arriba y las de baja prioridad abajo.',
    empty: 'Aún no es miembro de ningún proyecto',
    archived: 'Archivado',
  },
  taskHistory: {
    empty: 'Aún no hay tareas registradas aquí',
    empty_hint: 'Inicia un temporizador en una tarea o cambia el periodo y los filtros.',
    search: 'Buscar',
    period: 'Periodo',
    projects: 'Proyectos',
    stages: 'Etapas',
    search_placeholder: 'Buscar por nombre o número',
    projects_placeholder: 'Todos los proyectos',
    stages_placeholder: 'Todas las etapas',
    all: 'Todo el tiempo',
    today: 'Hoy',
    yesterday: 'Ayer',
    last_week: 'La semana pasada',
    last_month: 'El mes pasado',
    older: 'Anteriores',
  },
  myTasks: {
    task_sorted_by_priority: 'Tareas por prioridad',
    mentions: 'Menciones',
    recents: 'Recientes',
    liked: 'Favoritas',
    total: 'en total',
    total_unreads: 'sin leer',
    total_updates: 'actualizaciones',
    no: 'ninguna',
    markAllAsRead: 'Marcar todas como leídas',
    marking: 'Marcando...',
    confirmMarkAllAsRead: '¿Marcar todas las menciones como leídas?',
    confirmMarkAllAsReadMessage: 'Esto marcará como leídas todas las tareas donde te han mencionado. Esta acción no se puede deshacer.',
    openProject: 'Abrir proyecto',
    open: 'Abrir',
  },
  menu: {
    Pause: 'Pausar',
    PauseUntilWindowActivation: 'Pausar hasta activar la ventana',
    PauseFor5Minutes: 'Pausar durante 5 minutos',
    PauseFor10Minutes: 'Pausar durante 10 minutos',
    Resume: 'Reanudar',
    myTasks: 'Mis tareas',
    nav_menu: 'Menú',
    nav_tasks: 'Tareas',
    nav_alerts: 'Avisos',
    nav_me: 'Yo',
    task_history: 'Historial de tareas',
    view_all_task_history: 'Ver todo el historial de tareas',
    __open_logs: 'Abrir registros',
    __check_updates: 'Buscar actualizaciones',
    __devtools: 'DevTools12',
    __quit: 'Salir',
    download_app: 'Obtener la app de escritorio',
    summary_report: 'Informe resumen',
    dayoff: 'Día libre',
    time_reports: 'Informes de tiempo y facturas',
    time_report: 'Informe de tiempo',
    invoice_generator: 'Generar factura',
    salary: 'Salario',
    profit_share: 'Reparto de beneficios',
    projects: 'Proyectos',
    create_project: 'Crear un nuevo proyecto',
    project_settings: 'Ajustes del proyecto',
    ai_assistant: 'Asistente de IA',
    profile: 'Perfil',
    dark_mode: 'Modo oscuro',
    my_screenshots: 'Mis capturas de pantalla',
    logout: 'Cerrar sesión',
    get_help: 'Obtener ayuda',
    about: 'Acerca de',
    ai_automation: 'IA y automatización',
    workspace: 'Espacio de trabajo',
    switch_workspace: 'Cambiar de espacio de trabajo',
    workspace_settings: 'Ajustes del espacio de trabajo',
    create_new_workspace: 'Nuevo espacio de trabajo',
    workspace_name: "Nombre del espacio de trabajo",
    personal_workspace: "Espacio de trabajo personal",
    create_workspace: "Crear",
    create_workspace_failed: "No se pudo crear el espacio de trabajo, inténtalo de nuevo",
    invite_to_project: 'Invitar a un usuario al proyecto',
    already_member_project: 'El usuario ya es miembro del proyecto',
    resend_invite_button: 'REENVIAR INVITACIÓN',
    no_users_found: 'No se encontró ningún usuario, introduce un correo para invitar.',
    invite_failed: 'No se pudo invitar a {email}: comprueba la dirección',
    settings: 'ajustes',
    Project_name: 'Nombre del proyecto',
    task_short_id: 'Se usa para los ID cortos de las tareas',
    Task_ID_example: 'Ejemplo de ID de tarea',
    already_taken: 'Ya está en uso en el espacio de trabajo',
    Please_change: 'Cámbialo, por favor',
    Prefix: 'Prefijo',
    Template: 'Plantilla',
    Project_background: 'Fondo del proyecto',
    change: 'CAMBIAR',
    create: 'CREAR',
    Select_a_picture: 'Selecciona una imagen',
    Examples: 'Ejemplos:',
    pick_a_color: 'O elige un color',
    create_project_hint: 'Ponle nombre, elige una plantilla de columnas y un fondo.',
    Search_pictures: 'Buscar imágenes — abstracto, degradado, luces…',
    Create_project: 'Crear proyecto',
    Resend_invite: 'Reenviar la invitación al proyecto y al espacio de trabajo a',
    user_invite: 'Haz clic en un usuario para invitarlo',
    get_app: 'Obtener la app',
    add_task: 'Añadir',
    mentions_notify_1: 'Tienes',
    mentions_notify_2_single: 'tarea con mención',
    mentions_notify_2_multy: 'tareas con menciones',
    task_create: 'Crear una tarea',
    notifications: 'Notificaciones',
    no_new_notifications: 'No hay notificaciones nuevas',
    new_notification: 'nueva',
    new_notifications: 'nuevas',
  },
  reports: {
    executors: 'Ejecutores',
    now_working: 'Trabajando ahora',
    no_active_tasks: 'No hay tareas activas',
    work_one_day: 'Trabajo de un día',
    today: 'HOY',
    work_this_month: 'Trabajo de este mes',
    member: 'Miembro',
    activity: 'Actividad',
    total: 'Total',
    no_time_tracked: 'No se ha registrado tiempo',
    no_time_tracked_this_month: 'Este mes no se ha registrado tiempo',
    date_range: 'Rango de fechas',
    select_date_range: 'Selecciona un rango de fechas',
    show_filters: 'Mostrar filtros',
    hide_filters: 'Ocultar filtros',
    filter_projects: 'Incluir proyectos',
    select_projects: 'Selecciona proyectos',
    filter_labels: 'Solo tareas con etiquetas',
    filter_exclude_labels: 'Excluir tareas con etiquetas',
    select_label: 'Selecciona una etiqueta',
    filter_executors: 'Filtrar ejecutores',
    select_executors: 'Selecciona ejecutores',
    group_by: 'Agrupar por',
    group_projects: 'Proyectos',
    by_weeks: 'Por semanas',
    by_month: 'Por mes',
    dont_group: 'No agrupar',
    no_tasks: 'No hay tareas para esta consulta',
    total_time: 'Tiempo total',
    total_time_by_day: 'Tiempo total por día',
    burnup_chart: 'Gráfico burnup',
    all_spent: 'TOTAL<br/>DEDICADO',
    time_by_task: 'Tiempo por tarea',
    invoice: 'Crear factura',
    roles: 'Roles',
    search: 'Buscar',
    select_all: 'Seleccionar todo',
    unselect_all: 'Deseleccionar todo',
    now: 'ahora',
    Enter_project_name: 'Introduce el nombre del proyecto',
    screenshots: 'CAPTURAS DE PANTALLA',
    empty: 'Vacío',
    screenshots_empty_title: 'No hay capturas',
    screenshots_empty_hint: 'No se capturó nada para las fechas y los filtros seleccionados.',
    time_empty_title: 'No hay tiempo registrado',
    time_empty_hint: 'No se registró tiempo para las fechas y los filtros seleccionados.',
    last_month: 'Mes pasado',
    this_month: 'Este mes',
    this_year: 'Este año',
    all_time: 'Todo el tiempo',
    Ok: 'Ok',
    YES: 'SÍ',
    CANCEL: 'CANCELAR',
    Cancel: 'Cancelar',
    Tasks: 'TAREAS',
    Time: 'Tiempo',
    Tasks_details: 'DETALLES DE LAS TAREAS',
    PriorityLow: 'Baja',
    PriorityUsual: 'Normal',
    PriorityHigh: 'Alta',
    PriorityUrgent: 'Urgente',
    PrioritySuperUrgent: 'Muy urgente',
    Unset: 'Sin definir',
    enter_variables_values: 'Introduce los valores de las variables',
    are_you_sure_delete_template: '¿Seguro que quieres eliminar la plantilla?',
    are_you_sure_new_template: '¿Seguro que quieres guardar esta plantilla?',
    Template: 'Plantilla',
    Select_template: 'Selecciona una plantilla',
    New_template_name: 'Nombre de la nueva plantilla',
    DOWNLOAD_PDF: 'DESCARGAR PDF',
    basic_example: 'Ejemplo básico',
    worker_salary: 'Salario del trabajador',
    devforth_salary: 'Salario de Devforth',
    executor: 'Ejecutor',
    created: 'Creado',
    contributors: 'Colaboradores',
    value: 'Valor',
    progress: 'Progreso',
    accuracy: 'Precisión',
    spent_by: 'Dedicado por',
    by_executor: 'ejecutor',
    total_spent_by: 'Total dedicado',
    by_contributors: 'por los colaboradores',
    export: 'Exportar',
    configure_columns: 'Configurar columnas',
    more_actions: 'Más acciones',
    round_hours_to: 'Redondear las horas a',
    export_to_csv: 'Exportar a CSV',
    export_to_gsheets: 'Exportar a Google Sheets',
  },
  placeholders: {
    e_g: 'p. ej. Nuevo proyecto',
    Type_anything: 'Escribe cualquier cosa',
  },
  settings: {
    configure: 'Configurar el proyecto',
    delete_project: 'Eliminar el proyecto',
    Can_not_be_empty: 'No puede estar vacío',
    New_prefix: 'Nuevo prefijo',
    Save: 'Guardar',
    SaveAs: 'Guardar como',

    Cancel: 'Cancelar',
    general: 'general',
    Labels: 'Etiquetas',
    Members: 'Miembros',
    Tracker_Rules: 'Botones de flujo',
    Stages: 'Etapas',
    No_labels_yet: 'Todavía no hay etiquetas',
    Admin: 'Administrador',
    Not_a_member: 'No es miembro',
    Member: 'Miembro',
    Role_on_project: 'Rol en el proyecto',
    Actions: 'Acciones',
    Permissions: 'Permisos',
    Other: 'Otros',
    Invite_member: 'Invitar miembro',
    exclude_the_user: '¿Seguro que quieres excluir al usuario del proyecto?',
    Exclude: 'Excluir',
    Configure_workspace: 'Configurar el espacio de trabajo',
    Workspace_name: 'Nombre del espacio de trabajo',
    Logo: 'Logo',
    save: 'Guardar',
    Workspace_UI_language: 'Idioma del espacio de trabajo',
    Workspace_alias: 'Alias del espacio de trabajo',
    General: 'General',
    Priorities: 'Prioridades',
    Edit_tag_name: 'Editar el nombre de la etiqueta:',
    Pick_a_color: 'Elige un color',
    DELETE_TAG: 'ELIMINAR ETIQUETA',
    ARCHIVE_TAG: 'ARCHIVAR ETIQUETA',
    UNARCHIVE_TAG: 'DESARCHIVAR ETIQUETA',
    TASKS: 'TAREAS',
    EDIT: 'EDITAR',
    confirm_delete: '¿Seguro que quieres eliminar el proyecto?',
    archive: 'Archivar | archivar | Archivado',
    unarchive: 'Desarchivar | desarchivar',
    confirm_archive: '¿Quieres {action} este proyecto?',
    cant_undone: 'Esto no se puede deshacer',
    confirm_user_deletion: '¿Seguro que quieres eliminar al usuario?',
    CANCEL: 'CANCELAR',
    YES: 'SÍ',
    Yes: 'Sí',
    delete: 'Eliminar',
    only_admin_can_delete_user: 'Solo el administrador del espacio de trabajo puede eliminar a un miembro',
    only_admin_can_change_language: 'Solo el administrador del espacio de trabajo puede cambiar el idioma',
    ADMIN: 'Administrador',
    MEMBER: 'Miembro del equipo',
    GUEST: 'Invitado',
    FINANCE: 'Responsable financiero',
    admin_description: 'Tiene acceso total',
    finance_description: 'Como un miembro, pero además tiene acceso a todas las plantillas de facturas',
    member_description: 'Solo puede acceder a los proyectos a los que ha sido invitado, pero puede ver los informes de tiempo de todos los miembros y todos los proyectos. Puede ver los nombres de las tareas de proyectos ajenos.',
    guest_description: 'Solo puede acceder a los proyectos a los que ha sido invitado y ve los informes de tiempo de todos los miembros de esos proyectos.',
    doScreenshots: 'Hacer capturas de pantalla para demostrar el trabajo',
    single_admin_role_warning: 'No puedes modificar los permisos del único administrador',
    owner_role_warning: 'No puedes modificar los permisos del propietario del espacio de trabajo',
  },
  workspaceSettings: {
    general_subtitle: 'Nombre del espacio de trabajo, logotipo, idioma y color de marca',
    members_subtitle: 'Personas en este espacio de trabajo y sus roles',
    priorities_subtitle: 'Orden de proyectos en «Mis tareas» de cada miembro',
    name_saved: 'Nombre del espacio de trabajo guardado',
    logo_saved: 'Logotipo del espacio de trabajo guardado',
    timezone_saved: 'Zona horaria principal guardada',
    brand_color: 'Color de marca',
    main_timezone: 'Zona horaria principal',
    search_timezone: 'Buscar zona horaria',
    language: 'Idioma',
    role: 'Rol',
    admins: 'Administradores',
    pending_invites: 'Invitaciones pendientes',
    name_hint: 'Se muestra en el selector de espacios de trabajo y en las invitaciones.',
    language_hint: 'Idioma predeterminado para todos en el espacio de trabajo.',
    brand_color_hint: 'Se usa en los informes exportados a Google Sheets.',
    timezone_hint: 'Los informes de tiempo y las facturas cuentan los días en esta zona horaria. Solo el propietario y los administradores pueden cambiarla.',
  },
  projectSettings: {
    group_project: 'Proyecto',
    group_people: 'Personas',
    group_automation: 'Automatización',
    integrations: 'Integraciones',
    general_subtitle: 'Nombre y apariencia del proyecto',
    tags_subtitle: 'Etiquetas para categorizar las tareas de este tablero',
    stages_subtitle: 'Columnas del tablero — reordénalas para cambiar el flujo',
    members_subtitle: 'Personas con acceso a este proyecto y sus roles',
    flow_subtitle: 'Acciones de los botones de flujo de la página de tarea, por etapa',
    integrations_subtitle: 'Servicios conectados que informan a Tracklify',
    tasks_total: 'Tareas en total',
    name_hint: 'Se muestra en la barra lateral, en la cabecera del tablero y en cada referencia de tarea.',
    background: 'Fondo del tablero',
    background_hint: 'Imagen detrás de las columnas. Atenuada para que las tarjetas sigan legibles.',
    no_background: 'Sin fondo',
    photo_by: 'Foto de',
    screenshots_hint: 'Capturas de pantalla mientras corre el temporizador, adjuntas al tiempo registrado.',
    enabled: 'Activado',
    disabled: 'Desactivado',
    change: 'Cambiar',
    archive_title: 'Archivar este proyecto',
    archive_hint: 'Lo oculta de la barra lateral y del selector de tableros. El tiempo registrado se mantiene en los informes — puedes restaurarlo cuando quieras.',
    archive_button: 'Archivar proyecto',
    unarchive_title: 'Restaurar este proyecto',
    unarchive_hint: 'Lo devuelve a la barra lateral y al selector de tableros.',
    unarchive_button: 'Desarchivar proyecto',
    delete_title: 'Eliminar este proyecto',
    delete_hint: 'Elimina el proyecto junto con sus tareas.',
    tag: 'Etiqueta',
    used_on: 'Usada en',
    tasks_count: '{count} tareas',
    edit: 'Editar',
    archived: 'Archivada',
    archive: 'Archivar',
    unarchive: 'Desarchivar',
    add_tag: 'Añadir etiqueta',
    new_tag: 'Nueva etiqueta',
    tag_name: 'Nombre de la etiqueta',
    create: 'Crear',
    stage: 'Etapa',
    tasks: 'Tareas',
    order: 'Orden',
    add_stage: 'Añadir etapa',
    stage_name: 'Nombre de la etapa',
    rename_stage: 'Renombrar etapa',
    stage_name_hint: 'Se muestra como título de la columna en el tablero.',
    to_save: 'para guardar',
  },
  projectRules: {
    when_task_in_stage: 'Cuando la tarea esté en la etapa',
    secondary_button: 'Botón secundario (izquierda)',
    primary_button: 'Botón principal',
    this_rule_willnot_work: 'Esta regla no funcionará',
    add_action: 'Añadir acción',
    similar_item_was_used: 'ya se usó un elemento similar',
    preview: 'Vista previa',
    move: 'Mover',
    move_to: 'Mover a',
    assign: 'Asignar',
    assign_if_not_assigned: 'Asignar si no está asignada',
    assign_mention: 'Asignar al mencionado',
    unassign: 'Quitar asignación',
    auto_click_after: 'Clic automático después de',
    activate_button_if_user_mentioned_in_comment: 'Activar el botón si el usuario es mencionado en un comentario',
    auto_click_after_tracked_1: 'Clic automático después de',
    auto_click_after_tracked_2: 'registrados',
    minutes: 'm',
    Me: 'Yo',
    Task_creator: 'Creador de la tarea',
    no_buttons: 'No se muestran botones',
  },
  task: {
    edited: 'editado',
    Actions: 'Acciones',
    noDescription: 'Todavía no hay descripción',
    timeSpent: 'Tiempo dedicado',
    ago: 'atrás',
    by: ', por',
    ADD_A_CHECKLIST: 'AÑADIR UNA LISTA DE TAREAS',
    ADD_A_CHECKLIST_ITEM: 'AÑADIR UN ELEMENTO A LA LISTA',
    Created_task_in: 'Tarea creada en',
    Assigned: 'Asignada',
    Changed_task_description: 'Cambió la descripción de la tarea',
    Transferred_task_from: 'Tarea transferida desde',
    Type_comment: 'Escribe un comentario',
    SET_EST: 'ESTIMAR',
    SET_ESTIMATE: 'DEFINIR ESTIMACIÓN',
    Clear: 'Borrar',
    STORY_POINTS: 'STORY POINTS',
    Estimate: 'Estimación',
    Progress: 'Progreso',
    Add_time: 'Añadir tiempo',
    est: 'est',
    Code_block: 'Bloque de código',
    List: 'Lista',
    Video: 'Vídeo',
    USUAL: 'NORMAL',
    PRIO: 'Prioridad',
    Set_estimate_to: 'Definir la estimación en',
    Set_priority: 'Definir la prioridad',
    Delete_task: 'Eliminar la tarea',
    Screenshots: 'Ver capturas de pantalla',
    Add_manual_time: 'Añadir tiempo manualmente',
    Add_to_liked: 'Añadir a favoritas',
    CANCEL: 'CANCELAR',
    YES: 'SÍ',
    Back_to_task: 'Volver a la tarea',
    What_were_you_doing: '¿En qué estabas trabajando?',
    manual_how_long: '¿Cuánto tiempo?',
    manual_set_exactly: 'o indícalo con exactitud',
    manual_description_placeholder: 'p. ej. Llamada con el cliente sobre la hoja de ruta del Q4',
    manual_request: 'Solicitar {duration}',
    manual_pick_hint: 'Arrastra sobre la barra para elegir cuándo trabajaste',
    manual_tab_range: 'Intervalo',
    manual_tab_duration: 'Duración',
    manual_today: 'Hoy',
    manual_earlier: 'Antes',
    manual_later: 'Después',
    manual_legend_tracked: 'Registrado',
    manual_legend_request: 'Esta solicitud',
    manual_time_admin_required: 'El tiempo manual lo revisa un administrador del espacio de trabajo, y este proyecto no tiene ninguno. Añade uno al proyecto:',
    manual_time_request_refused: 'No se solicitó el tiempo manual. Recarga la página e inténtalo de nuevo.',
    manual_time_update_refused: 'No se actualizó el tiempo manual: ya se gestionó o ya no tienes acceso. Recarga la página para ver su estado actual.',
    Type_item: 'Escribe un elemento',
    to_normal: 'a normal',
    ASSIGN: 'Asignar',
    SEARCH_ASSIGNEE: 'Buscar responsable',
    add: 'añadir',
    change: 'cambiar',
    nowin: 'ahora en',
    Tags: 'Etiquetas',
    Unassign: 'Quitar asignación',
    just_now: 'ahora mismo',
    Removed_assignee: 'Responsable eliminado',
    Moved_to: 'Movida a',
    Added_tag: 'Etiqueta añadida',
    Removed_tag: 'Etiqueta eliminada',
    Added: 'Añadido',
    Reqested_to_add: 'Solicitó añadir',
    Approved: 'Aprobado',
    Rejected: 'Rechazado',
    Canceled: 'Cancelado',
    Deleted: 'Eliminado',
    by_trigger: 'por un disparador',
    REMOVE: 'ELIMINAR',
    Are_you_sure: '¿Estás seguro?',
    Are_you_sure_you_want_to_delete_this_image: '¿Seguro que quieres eliminar esta imagen?',
    set_as_task_preview: 'Establecer como vista previa de la tarea',
    max_images_reached: 'Puedes subir un máximo de {limit} imágenes a la vez',
    current_task_preview: 'Vista previa actual de la tarea',
    next_image: 'Siguiente imagen',
    previous_image: 'Imagen anterior',
    Are_you_sure_you_want_to_delete_this_comment: '¿Seguro que quieres eliminar este comentario?',
    Are_you_sure_you_want_to_delete_this_checklist_item: '¿Seguro que quieres eliminar este elemento de la lista de verificación?',
    Delete: 'Eliminar',
    Yes: 'Sí',
    No: 'No',
    manual_CANCEL: 'Cancelar',
    manual_Remove: 'Eliminar',
    manual_YES: 'SÍ',
    delete_screenshot_title: '¿Eliminar esta captura de pantalla?',
    delete_screenshot_subtitle: 'Esto no se puede deshacer',
    Add_tags: 'Añadir etiquetas',
    create_new_tag: 'Crear nueva etiqueta',
    No_screenshots_here_enable: 'Todavía no hay capturas de pantalla aquí, registra tiempo y aparecerán',
    No_screenshots_here_disable: 'Las capturas de pantalla están desactivadas para este proyecto',
    No_screenshots_here_disable_admin_part1: 'Las capturas de pantalla están desactivadas para este proyecto, abre los ',
    No_screenshots_here_disable_admin_part2: 'ajustes',
    No_screenshots_here_disable_admin_part3: ' para cambiarlo',
    SPENT: 'DEDICADO',
    oops: '¡Ups!',
    cannot_find_page: 'No encontramos la página que buscabas',
    start_from_home: 'Empezar desde el inicio',
    nf_title: 'Aquí no hay nada que ver.',
    nf_subtitle: 'La página que solicitaste no existe. Comprueba la URL o vuelve a un lugar conocido.',
    go_to_homepage: 'Ir a la página de inicio',
    go_back: 'Volver',
    spent_time: 'Tiempo dedicado',
    copy_to_clipboard: 'Copiar al portapapeles',
    copied_to_clipboard: 'El enlace se ha copiado al portapapeles',
    copy_video_link: 'Copiar enlace',
    volume: 'Volumen',
    converting_video: 'Convirtiendo…',
    picture_in_picture: 'Imagen en imagen',
    expand_video: 'Ampliar',
    collapse_video: 'Reducir',
    we_are_still_processing_video: 'Todavía estamos procesando el vídeo',
    video_available_not_for_all_platforms: 'El vídeo aún no está disponible en plataformas que no admiten formatos de vídeo modernos. Estamos realizando una conversión adicional a MP4. Espera, por favor.',
    move_to: 'Mover a',
    unassign: 'Quitar asignación',
    assign: 'Asignar',
    unable_to_restore_image: 'No se pudo restaurar la imagen',
    Record_screen: 'Grabar la pantalla',
    screenshot_activity: 'Actividad',
    my_last_screenshots: 'Mis últimas capturas de pantalla',
    view_all: 'Ver todas',
    Executor: 'Ejecutor',
    edit: 'editar',
    Stage: 'Etapa',
    NoStage: 'Sin etapa',
    Change_project: 'Cambiar de proyecto',
    Please_select_project_to_move: 'Selecciona el proyecto al que mover',
    No_transfer_available: 'No hay transferencia disponible',
    Created_by: 'Creado por',
    PriorityLow: 'Baja',
    PriorityUsual: 'Normal',
    PriorityHigh: 'Alta',
    PriorityUrgent: 'Urgente',
    PrioritySuperUrgent: 'Muy urgente',
    Unset: 'Sin definir',
    transfer_unavailable: {
      not_creator: 'Solo el creador puede transferir, y tú no eres el creador',
      single_project: 'Solo hay un proyecto, así que no hay ninguno al que transferir',
      child_task: 'No se puede transferir una subtarea por separado',
    },
    are_you_sure_transfer_task: '¿Seguro que quieres transferir la tarea?',
    time_save_but_screenshots_unavailable: 'Las capturas de pantalla del registro y el tiempo registrado se guardarán, pero no estarán disponibles en la tarea transferida.',
    screenshots_from_tracked_time: 'Capturas de pantalla del tiempo registrado',
  },
  theme: {
    title: 'Tema',
    dark: 'Oscuro',
    light: 'Claro',
    pink: 'Rosa',
    violet: 'Violeta',
    lime: 'Lima',
  },
  themeEditor: {
    new_theme: 'Nuevo tema',
    new_title: 'Nuevo tema',
    edit_title: 'Editar tema',
    unsaved_message: 'Los cambios del tema aún no se han guardado.',
    name: 'Nombre',
    name_placeholder: 'Mi tema',
    mode: 'Modo',
    colors: 'Colores',
    seed_base: 'Fondo',
    seed_ink: 'Texto',
    seed_accent: 'Acento',
    fine_tune: 'Ajuste fino',
    overrides_hint: 'Opcional. Los colores vacíos siguen a los de arriba.',
    token_bg2: 'Paneles',
    token_control: 'Botones',
    token_card: 'Tarjetas',
    token_chrome: 'Barra superior',
    token_line: 'Bordes',
    'token_text-muted': 'Texto secundario',
    'token_accent-soft': 'Tinte de acento',
    token_red: 'Rojo',
    token_green: 'Verde',
    token_blue: 'Azul',
    reset: 'Restablecer',
    share: 'Compartir con el espacio',
    share_hint: 'Los miembros de {workspace} también podrán elegirlo',
    shared: 'Compartido con el espacio',
    shared_by: 'Compartido por {name}',
    delete: 'Eliminar',
    delete_title: '¿Eliminar tema?',
    cancel: 'Cancelar',
    save: 'Guardar',
    preview: 'Vista previa',
    preview_project: 'Rediseño del sitio',
    preview_search: 'Buscar',
    preview_filters: 'Filtros',
    preview_filter_mine: 'Mis tareas',
    preview_filter_tagged: 'Con etiquetas',
    preview_filter_tracked: 'Registrado hoy',
    preview_todo: 'Por hacer',
    preview_doing: 'En curso',
    preview_done: 'Hecho',
    preview_card_onboarding: 'Pantallas de bienvenida',
    preview_card_ora: 'Limitar el spam de ORA ORA ORA en comentarios',
    preview_card_invoices: 'Facturas mensuales',
    preview_card_icons: 'Nuevo set de iconos',
    preview_card_clash_royale: 'Nerf Mega Knight',
    preview_tag_bug: 'Bug',
    preview_tag_design: 'Diseño',
    preview_tag_release: 'Lanzamiento',
  },
  profile: {
    password_title: 'Haz que sea difícil de adivinar',
    password_hint: 'Los requisitos se iluminan mientras escribes.',
    rule_length: '{count} caracteres o más',
    rule_number: 'Al menos un número',
    rule_uppercase: 'Una letra mayúscula',
    rule_match: 'Las contraseñas coinciden',
    rule_no_spaces: 'Sin espacios',
    rule_different: 'Diferente de la contraseña actual',
    save_password: 'Guardar contraseña',
    username_required: 'El nombre no puede estar vacío',
    profile_saved: 'Perfil guardado',
    username_invalid: "El nombre solo puede contener letras, dígitos, espacios y . , - _ ' ’ & ( ) {'@'} +",
    profile_save_failed: "No se pudo guardar el perfil, inténtalo de nuevo",
    password_changed: 'Contraseña cambiada',
    delete_title: '¿Eliminar tu cuenta?',
    will_be_removed: 'Se eliminará',
    removed_profile: 'Perfil, foto y preferencias',
    removed_access: 'Acceso a todos los espacios de trabajo y proyectos',
    removed_settings: 'Días libres y configuración personal',
    type_delete_prefix: 'Escribe',
    type_delete_suffix: 'para confirmar',
    keep_account: 'Mantener cuenta',
    delete_forever: 'Eliminar para siempre',
    subtitle: 'Los datos y preferencias de tu cuenta personal',
    section_photo: 'Foto de perfil',
    section_personal: 'Información personal',
    section_appearance: 'Apariencia',
    section_security: 'Seguridad',
    section_danger: 'Zona de peligro',
    upload_new: 'Subir nueva',
    photo_hint: 'PNG o JPG, hasta 5 MB',
    name_hint: 'Visible para tus compañeros en tareas y comentarios',
    theme_hint: 'Se aplica a todos tus espacios de trabajo y dispositivos de Tracklify',
    change_password: 'Cambiar contraseña',
    delete_account_hint: 'Elimina permanentemente tu cuenta y todos los datos personales. Esto no se puede deshacer.',
    delete_account_button: 'Eliminar cuenta',
    Cancel: 'Cancelar',
    old_password_placeholder: 'Introduce tu contraseña actual',
    new_password_placeholder: 'Al menos {count} caracteres',
    repeat_password_placeholder: 'Repite la nueva contraseña',
    days_off_visibility_hint: 'Elige quién puede ver cuándo estás ausente en tus proyectos',
    days_off_everyone: 'Todos',
    days_off_members_only: 'Solo miembros',
    unsaved_changes: 'Tienes cambios sin guardar',
    Configure_user_profile: 'Configurar el perfil de usuario',
    General: 'General',
    Privacy: 'Privacidad',
    days_off_visibility_title: '¿Quién puede ver mis días libres?',
    days_off_visible_to_everyone: 'Todos en mis proyectos, incluidos los invitados del espacio de trabajo',
    days_off_hidden_from_guests: 'Solo los miembros y administradores del espacio de trabajo en mis proyectos',
    Name_Surname: 'Nombre y apellidos',
    Avatar: 'Avatar',
    Email: 'Correo electrónico',
    CHANGE_PASSWORD: 'CAMBIAR CONTRASEÑA',
    DELETE_ACCOUNT: 'ELIMINAR LA CUENTA DE USUARIO',
    Old_password: 'Contraseña antigua',
    New_password: 'Nueva contraseña',
    Repeat_new_password: 'Repite la nueva contraseña',
    CANCEL: 'CANCELAR',
    Fill_this_field: 'Rellena este campo',
    Old_password_is_incorrect: 'La contraseña antigua es incorrecta',
    Password_must_be_same: 'Las contraseñas deben coincidir',
    Change_user_password: 'Cambiar la contraseña del usuario',
    Password_must_be_at_least: 'La contraseña debe tener al menos',
    characters: 'caracteres',
    destroy_your_account: 'Esto destruirá el registro de tu cuenta de usuario',
    type_delete_to_confirm: 'Escribe DELETE si estás seguro',
    delete_me: 'ELIMÍNAME',
  },
  time: {
    M: 'M',
    S: 'S',
    d: 'd',
    w: 'sem',
    y: 'a',
    H: 'H',
  },
  button: {
    Yes: 'Sí',
  },
  recording: {
    Record_your_screen: 'Graba tu pantalla',
    Record_Microphone: 'Grabar el micrófono',
    Record_Webcam: 'Grabar la cámara web',
    cant_start_rec: 'No se puede iniciar la grabación de pantalla, ¿has seleccionado una pantalla? Error',
    Cant_start_camera: 'No se puede iniciar la grabación con la cámara, ¿has concedido los permisos? Error',
    Webcamera_preview: 'Vista previa de la cámara web',
    Start_recording: 'Iniciar la grabación',
    recording_screen_now: 'Estás grabando tu pantalla ahora mismo',
    Stop_recording: 'Detener la grabación',
  },
  loader: {
    Loading: 'Cargando',
  },
  rule: {
    When: 'Cuando',
    Else: 'Si no',
    Action: 'Acción',
    Condition: 'Condición',
  },
  trackTimeBar: {
    Unassign: 'Quitar asignación',
  },
  downloadMobile: {
    Get_Tracklify_mobile: 'Consigue la app móvil de Tracklify',
    Browse: 'Explorar',
    discuss_your_tasks: 'comenta tus tareas, gestiona el equipo desde el móvil o',
    quickly_creates_tasks: 'crea tareas rápidamente a partir de capturas compartidas',
    You_have_Tracklify: 'Ya tienes la app de Tracklify en tu smartphone',
    Reports: 'Informes',
  },
  title: {
    select_text_and: 'selecciona el texto y ctrl + l',
  },
  trackingNotice: {
    __tracking_going: 'Tracklify va a hacer capturas de pantalla para demostrar el tiempo dedicado a tu trabajo',
    __please_share: 'Comparte toda tu pantalla para que podamos capturarla',
    __choose_entire_screen: 'En la ventana del navegador, elige Toda la pantalla y luego haz clic en Compartir',
    __window_or_tab_wont_work: 'Compartir una sola ventana o pestaña de Chrome no funcionará',
    __tracking_makes_screenshots:
      'Tracklify hace solo una captura de pantalla cada 10 minutos, con pequeños desplazamientos de tiempo aleatorios',
    __screenshots_securely:
      'Las capturas se almacenan de forma segura en la nube y siempre se pueden revisar y eliminar (con pérdida de tiempo)',
    __press_cancel: 'Pulsa Cancelar si no quieres demostrar tu tiempo',
    __good_try: '¡Buen intento!',
    __selected_one: 'Pero has seleccionado',
    __selected_two: 'en lugar de toda la pantalla',
    __canceled_sharing: 'Has cancelado el uso compartido de pantalla',
    __unfortunately: 'Por eso no podrás confirmar tu tiempo',
    __you_ws_admin: 'Como eres administrador del espacio de trabajo, puedes:',
    __we_will_notify: 'Te avisaremos cuando se haga una captura o cuando el registro se detenga',
    __please_notify: 'permite las notificaciones, por favor',
    __notifications_only:
      'Tracklify usa las notificaciones solo para informarte de las actualizaciones del estado del registro',
    __we_recommended_notifications:
      'También recomendamos comprobar que las notificaciones del navegador estén activadas en los ajustes del sistema',
    __we_recommended_idle: 'Recomendamos activar el permiso «Uso del dispositivo»',
    __we_will_idle: 'Comprobaremos tu inactividad',
    __needs_device_use:
      'Tracklify usa el permiso «Uso de tu dispositivo» para detener automáticamente el registro cuando te alejas del ordenador durante más de 10 minutos.',
    __provide_better:
      'Este ajuste se usa solo para ofrecer una mejor experiencia, no se envía al servidor ningún dato de uso del dispositivo.',
    __well_done: 'Bien hecho',
    __we_recommended_hide_popup: 'Recomendamos ocultar la molesta ventana emergente del navegador',
    __just_press: 'Solo pulsa Ocultar:',
    __to_leave: 'Para dejar el trabajo y detener el registro, simplemente cierra la pestaña del navegador con Tracklify',
    __sorry_we_cant: 'Lo sentimos, no podemos iniciar el registro',
    __we_dont_have_perm: 'No tenemos permiso para acceder a tu actividad. Restablece todos los permisos para que el navegador pueda volver a solicitarlos.',
    __try_again_btn: 'Intentar de nuevo',
    __dont_track: 'Vale, no registrar horas',
    __enable_without: 'Activar el registro de tiempo sin capturas de pantalla para el proyecto',
    __dont_show_again: 'No volver a mostrar',
    __close: 'Cerrar',
    andReload: 'Y recargar la página',
    __choose_chrome_browser: 'Como Tracklify usa la moderna API de detección de inactividad, solo funciona en el navegador Chrome (u otros basados en Chrome)',
    __otherwise: 'Si no, puedes descargar nuestra app de escritorio aquí:',
    __download: 'DESCARGAR',
    __update_tracker: 'Actualizar',
    __installing_update: 'Instalando…',
    __update_failed: 'La actualización falló. Haz clic en «Actualizar» para volver a intentarlo.',
    __you_can_disable_screenshots: 'Como eres el creador del proyecto, puedes desactivar las capturas de pantalla en los',
    __project_settings: 'ajustes del proyecto',
  },
  addTask: {
    tags: 'Etiquetas',
    no_tags: 'Sin etiquetas',
    no_tags_hint: 'Este proyecto aún no tiene etiquetas.',
    add_tags: 'Añadir etiquetas',
    search_tags: 'Buscar etiquetas...',
    nothing_found: 'No se encontró nada',
    create_tag: 'crear «{name}»',
    clear_all: 'Borrar todo',
    more_available: '{count} más disponibles',
    create_task: 'Crear tarea',
    create_subtask_for: 'Crear subtarea para {task}',
    placeholder: 'Escribe aquí el texto de la tarea',
    select_picture: 'Selecciona una imagen',
    ctrl_v_paste: 'Ctrl+V para pegar una imagen del portapapeles',
    tap_to_attach: 'Toca para adjuntar una imagen',
    or: 'o',
    select_exactly_image: 'Selecciona un archivo de imagen',
  },
  invoiceAutoGen: {
    button: 'Autogenerar',
    save_template_first: 'Guarda primero la plantilla',
    title: 'Autogenerar factura',
    description: 'Se genera el día 1 de cada mes para el mes anterior, con los filtros actuales del informe.',
    active: 'Activa',
    off: 'Desactivada',
    next_invoice_in: 'Próxima factura en 1 día | Próxima factura en {count} días',
    not_generated: 'No se generarán facturas',
    turn_off: 'Desactivar',
    save_failed: 'No se pudo activar la autogeneración: comprueba las direcciones',
    invoice_for: '{date} · factura de {month}',
    sent_to: 'Enviada a 1 destinatario | Enviada a {count} destinatarios',
    will_be_sent_to: 'Se enviará a 1 destinatario | Se enviará a {count} destinatarios',
    email: 'Correo',
    additional_email: 'Correo adicional',
    additional_email_placeholder: "p. ej. accountant{'@'}company.com",
    initiated_by: 'Iniciado por',
  },
  devtools: {
    title: 'IA y automatización',
    subtitle: 'Trabaja con Tracklify desde tu terminal y desde asistentes de código con IA.',
    copy: 'Copiar',
    regenerate: 'Regenerar',
    cli: {
      terminal: 'tracklify — cli',
      title: 'Obtener la CLI de Tracklify',
      subtitle: 'Obtén la aplicación CLI de Tracklify para automatizar operaciones como git.',
      token_hint: 'Tu token es personal y secreto. Guárdalo en un lugar seguro.',
      regenerate_title: '¿Regenerar el token de la CLI?',
      regenerate_subtitle: 'Todos los clientes con sesión iniciada tendrán que volver a entrar.',
      regenerated: 'Token de la CLI regenerado',
      regenerate_failed: 'No se pudo regenerar el token de la CLI',
      branch_hint: 'Crear una rama nueva para la tarea actual',
      branch_output: 'Creará una rama como feature/<projectname>/<taskHid>/<taskSlug>',
      commit_hint: 'Añadir una referencia a la tarea en el commit',
      commit_output: 'Creará un commit como "my text <projectname>/<taskHid>/<taskSlug>"',
    },
    mcp: {
      terminal: 'tracklify — mcp',
      title: 'Obtener el MCP de Tracklify',
      subtitle: 'Conecta un cliente MCP a tu espacio de trabajo de Tracklify.',
      token_hint: 'Añade esta cabecera con tu token personal. Da acceso a Tracklify en tu nombre, así que mantenlo en secreto.',
      regenerate_title: '¿Regenerar el token de MCP?',
      regenerate_subtitle: 'Los clientes que usen este token perderán el acceso. Las apps conectadas por OAuth seguirán funcionando.',
      regenerated: 'Token de MCP regenerado',
      regenerate_failed: 'No se pudo regenerar el token de MCP',
      claude_code_step1: 'Ejecuta en tu terminal.',
      claude_code_step2: 'Luego ejecuta en Claude Code, elige tracklify y selecciona Authenticate.',
      codex_step: 'Codex abre Tracklify en tu navegador para iniciar sesión; si no lo hace, ejecuta codex mcp login tracklify.',
      antigravity_step: 'Añádelo a ~/.gemini/config/mcp_config.json. Antigravity no tiene inicio de sesión OAuth para Tracklify, así que usa tu token personal.',
      other_step: 'Añade esta URL a tu cliente MCP. Con inicio de sesión OAuth abrirá Tracklify en tu navegador para pedir tu aprobación; si no, añade la cabecera de abajo.',
      key: 'Clave',
      value: 'Valor',
    },
    connections: {
      title: 'Apps conectadas',
      empty: 'Todavía no hay apps conectadas mediante inicio de sesión OAuth.',
      app: 'App',
      connected: 'Conectada',
      last_active: 'Última actividad',
      disconnect: 'Desconectar',
      disconnect_failed: 'No se pudo desconectar la app',
    },
  },
  profitShare: {
    breadcrumb: 'Proyecto Profit-share /',
    search_projects: 'Buscar proyectos Profit-share',
    author: 'Autor',
    no_accessible_projects: 'No hay proyectos accesibles',
    confidential_badge: 'Confidencial · capturas difuminadas',
    projects_stack: 'proyectos',
    members_stack: 'miembros',
    no_participating_projects: 'No hay proyectos participantes',
    only_author_access: 'Por ahora solo el autor tiene acceso.',
    edit_project: 'Editar proyecto',
    create_project: 'Crear proyecto Profit-share',
    return_to_admin: 'Volver a la vista de admin',
    view_as_non_admin: 'Ver como no admin',
    loading_project: 'Cargando proyecto Profit-share…',
    sections_aria: 'Secciones de Profit-share',
    tab_overview: 'Resumen e ingresos',
    tab_rates: 'Tarifas de miembros',
    tab_audit: 'Registro de auditoría',
    choose_title: 'Elige un proyecto Profit-share',
    access_count: 'Tienes acceso a {n} proyecto. | Tienes acceso a {n} proyectos.',
    opening_shows: 'Al abrir uno se muestran datos salariales confidenciales.',
    tracklify_projects_count: '{n} proyecto de Tracklify | {n} proyectos de Tracklify',
    members_count: '{n} miembro | {n} miembros',
    new_project: 'Nuevo proyecto',
    landing_kicker: 'Profit-share',
    landing_title: 'Reparte beneficios de forma transparente entre tus proyectos',
    landing_text: 'Un proyecto Profit-share agrupa los ingresos y los costes registrados de varios proyectos de Tracklify y reparte lo que queda entre los miembros participantes.',
    no_access_yet: 'Aún no tienes acceso a ningún proyecto Profit-share.',

    all_participating: 'Todos los proyectos participantes',
    overview_reveal_hint: 'Las tarifas y los costes de los miembros siguen siendo confidenciales hasta que se revela una celda de miembro y mes.',
    export_csv: 'Exportar CSV sin miembros',
    no_operations: 'Aún no hay operaciones registradas.',
    rate_missing: 'Falta la tarifa',
    vs_six_months: '{change} frente a hace 6 meses',
    carry_over: '({amount} arrastrado)',
    reveal_rate: 'Revelar tarifa',
    reveal_rate_aria: 'Revelar la tarifa de {member} para {month}',
    rate_line: 'tarifa {rate}',
    mentor_line: '+ mentor {rate}',
    no_effective_rate: 'Sin tarifa vigente',
    projects_loaded: '{n} proyecto cargado | {n} proyectos cargados',
    load_details: 'Proyecto «{name}» cargado en {seconds} s · consulta de agregación {query} s',
    loading_operations: 'Cargando operaciones de los proyectos…',
    no_participating_selected: 'No se han seleccionado proyectos participantes.',
    add_revenue: 'Añadir ingreso',
    revenue: 'Ingresos',
    latest: 'Último',
    no_description: 'Sin descripción',
    rate_not_set: 'Tarifa sin definir',
    delete_revenue_confirm: '¿Eliminar este ingreso?',
    delete_revenue: 'Eliminar ingreso',
    no_revenue: 'Aún no hay ingresos',
    no_revenue_hint: 'El beneficio seguirá en negativo hasta que se añadan ingresos.',
    update_revenue: 'Actualizar ingreso',
    revenue_invalid: 'El importe y la tarifa deben ser números positivos, p. ej. 1200.50',
    col_month: 'Mes',
    col_total_spend: 'Gasto total',
    col_rate_efficiency: 'Eficiencia de tarifa',
    col_monthly_profit: 'Beneficio mensual',
    col_distributable_profit: 'Beneficio repartible',
    col_accumulated_profit: 'Beneficio acumulado',

    tracklify_project: 'Proyecto de Tracklify',
    rate_per_hour: 'Tarifa ({currency}/h)',
    amount: 'Importe',
    currency: 'Moneda',
    date: 'Fecha',
    sold_hours: 'Horas vendidas',
    note: 'Nota',
    note_placeholder: 'p. ej. factura de septiembre',

    member_rates_title: 'Tarifas salariales de los miembros',
    rates_hint: 'Una actualización por miembro y mes. Una tarifa se aplica hasta que una actualización más reciente la sustituye.',
    rates_reveal_hint: 'Las tarifas siguen siendo confidenciales hasta que se revela una celda de miembro y mes.',
    add_rate_update: 'Añadir actualización de tarifa',
    no_rates_warning: 'Aún no hay tarifas. El gasto y el beneficio no se pueden calcular hasta que los miembros que registran tiempo tengan una tarifa.',
    select_projects_first: 'Selecciona proyectos participantes con miembros aprobados antes de añadir tarifas.',
    no_rate_history: 'Aún no hay historial de tarifas.',
    confidential_rate: 'Tarifa confidencial',
    edit_rate: 'Editar tarifa',
    mentor_rate_line: 'Mentor: {rate}',
    hours_not_estimated: 'Horas no estimadas',
    add_monthly_rate: 'Añadir actualización mensual de tarifa',
    add_rate: 'Añadir tarifa',
    rates_invalid: 'Las tarifas deben ser números, p. ej. 25.50',
    member: 'Miembro',
    search_members: 'Buscar miembros',
    no_members_found: 'No se encontraron miembros',
    month: 'Mes',
    new_rate: 'Nueva tarifa',
    mentor_rate: 'Tarifa de mentor',
    note_optional: 'Nota (opcional)',

    new_ps_project: 'Nuevo proyecto Profit-share',
    edit_ps_project: 'Editar proyecto Profit-share',
    project_name: 'Nombre del proyecto',
    project_name_placeholder: 'p. ej. Agency pool 2026',
    members_access: 'Miembros con acceso confidencial',
    add_members: 'Añade miembros del espacio de trabajo…',
    members_access_hint: 'Verán las tarifas salariales, los costes, los ingresos y el beneficio.',
    access_list_author_only: 'La lista de acceso confidencial solo la ve el autor del proyecto.',
    participating_projects: 'Proyectos de Tracklify participantes',
    add_projects: 'Añade proyectos…',
    participating_hint: 'Los admins del espacio de trabajo gestionan esta lista. Las tarifas se comparten entre todos los proyectos seleccionados.',
    create_project_btn: 'Crear proyecto',
    save_project: 'Guardar proyecto',

    reveal_title: '¿Revelar la tarifa confidencial?',
    warning: 'Aviso',
    reveal_admin_text: 'Estás revelando esta tarifa como administrador, así que este intento no se registrará en el registro de auditoría. Siguen aplicándose las mismas obligaciones de confidencialidad.',
    reveal_member_text: 'Si continúas, este intento de revelación quedará registrado de forma permanente en el registro de auditoría con tu cuenta. {member} podrá obtener información sobre este intento indefinidamente. La entrada no se puede eliminar y esta acción no se puede deshacer.',
    confidential_caps: 'CONFIDENCIAL',
    confidential_text: 'La información sobre tarifas es estrictamente confidencial y puede estar protegida por un acuerdo con el miembro. Al revelarla, asumes toda la responsabilidad de mantenerla segura.',
    revealing: 'Revelando…',
    reveal: 'Revelar',

    confidential: 'Confidencial',
    consent_title: 'Información sensible de Profit-share',
    rule_see_title: 'Lo que verás',
    rule_see_text: 'Este proyecto Profit-share muestra tarifas salariales confidenciales, costes registrados, ingresos y beneficios.',
    rule_stop_title: 'Se queda contigo',
    rule_stop_text: 'Cada miembro de la empresa tiene derecho a mantener en confidencialidad su tarifa salarial, su historial y los motivos. Aunque la transparencia del modelo Profit-share hace inevitable revelarla a los participantes autorizados, cualquier otra divulgación debe detenerse en la persona que la ve.',
    rule_share_title: 'No la compartas ni la registres',
    rule_share_text: 'No debes compartir ni registrar esta información en fuentes públicas, capturas, grabaciones de pantalla, mensajes ni de ninguna otra forma. Compartirla con alguien no autorizado puede suponer tu salida de Profit-share. Tracklify difumina automáticamente las capturas tomadas mientras Profit-share está abierto.',
    consent_agree: 'Entiendo todas las reglas y acepto que pueden retirarme de Profit-share si comparto o registro información confidencial de cualquier forma.',
    asked_again: 'Se te volverá a preguntar en un dispositivo o navegador nuevo.',
    agree_open: 'Aceptar y abrir',

    audit_title: 'Registro de auditoría',
    audit_hint_full: 'Cambios de ingresos, cambios de tarifas salariales y revelaciones de tarifas confidenciales.',
    audit_hint_limited: 'Actividad de ingresos y tus propias revelaciones de tarifas confidenciales.',
    loading_audit: 'Cargando registro de auditoría…',
    no_audit: 'Aún no hay entradas de auditoría.',
    page_info: 'Página {page} de {pages} · {total} entradas',
    col_time: 'Hora',
    col_user: 'Usuario',
    col_entity: 'Entidad',
    col_action: 'Acción',
    col_diff: 'Cambios',
    filter_all_full: 'Toda la actividad financiera',
    filter_all_limited: 'Ingresos y mis acciones',
    filter_salary: 'Tarifas salariales',
    filter_reveals: 'Revelaciones de tarifas',
    filter_my_reveals: 'Mis revelaciones de tarifas',
    entity_salary: 'Tarifa salarial',
    entity_reveal: 'Revelación de tarifa',
  },
  invoices: {
    invoice_basis: 'Base de la factura',
    close_invoice_basis: 'Cerrar base de la factura',
    close: 'Cerrar',
    edit_filters: 'Editar filtros',
    projects: 'Proyectos',
    include_tags: 'Incluir etiquetas',
    exclude_tags: 'Excluir etiquetas',
    executors: 'Ejecutores',
    count_projects: '{n} proyecto | {n} proyectos',
    count_incl_tags: '{n} etiqueta incl. | {n} etiquetas incl.',
    count_excl_tags: '{n} etiqueta excl. | {n} etiquetas excl.',
    count_executors: '{n} ejecutor | {n} ejecutores',
    block_formatting: 'Formato del bloque',
    font_size_value: 'Tamaño de fuente: {size}',
    font_size: 'Tamaño de fuente',
    alignment: 'Alineación',
    column_width: 'Ancho de columnas',
    delete_block: 'Eliminar bloque',
    delete_text_cell: 'Eliminar esta celda de texto',
    add_row_after: 'Añadir fila debajo',
    add_row_after_title: 'Añadir una fila nueva después de esta',
    delete_column: 'Eliminar columna',
    delete_column_title: 'Eliminar esta columna de la tabla',
    confirm_delete: '¿Confirmar eliminación?',
    confirm_deletion: 'Confirmar eliminación',
    cancel_deletion: 'Cancelar eliminación',
    yes: 'Sí',
    no: 'No',
    font_large: 'Fuente grande (16px)',
    font_medium: 'Fuente mediana (14px)',
    font_small: 'Fuente pequeña (12px)',
    font_extra_small: 'Fuente muy pequeña (10px)',
    align_left: 'Alinear a la izquierda',
    align_center: 'Centrar',
    align_right: 'Alinear a la derecha',
    equal_width_columns: 'Columnas de igual ancho',
    dynamic_width_columns: 'Columnas de ancho dinámico',
    invoice_generator: 'Generador de facturas',
    invoice_layout: 'Diseño de la factura',
    add_section: 'Añadir sección',
    add_text_section: 'Añadir sección de texto',
    add_table_section: 'Añadir sección de tabla',
    add_block_right: 'Añadir bloque a la derecha',
    add_column_right: 'Añadir columna a la derecha',
    empty_block: 'Bloque vacío',
    new_row_col: 'Nueva fila {row}, col. {col}',
    new_column: 'Nueva columna {n}',
    delete_table: 'Eliminar tabla',
    delete_row: 'Eliminar fila',
    delete_table_title: 'Eliminar toda la tabla',
    delete_row_title: 'Eliminar esta fila de la tabla',
    invoice_preview: 'Vista previa de la factura',
    download: 'Descargar',
    generating_pdf: 'Generando PDF…',
    opening_pdf_preview: 'Abriendo vista previa del PDF…',
    page_of: 'Página {current} de {total}',
    pdf_generation_failed: 'Error al generar el PDF',
    pdf_generation_error: 'Se produjo un error al generar la vista previa del PDF. Inténtalo de nuevo.',
    retry: 'Reintentar',
    saving: 'Guardando…',
    saved: 'Guardado',
    choose_template: 'Elige una plantilla de factura',
    choose_template_description: 'Elige una plantilla guardada para generar una factura de las tareas filtradas o empieza una nueva desde cero.',
    your_templates: 'Tus plantillas',
    legacy_badge: 'LEGACY',
    shared_badge: 'COMPARTIDA',
    created_date: 'Creada {date}',
    created_colon_date: 'Creada: {date}',
    last_pdf: 'Último PDF: {date}',
    never_capital: 'Nunca',
    never: 'nunca',
    or: 'o',
    create_new_template: 'Crear nueva plantilla',
    template_name: 'Nombre de la plantilla',
    save_name: 'Guardar nombre',
    cancel_renaming: 'Cancelar cambio de nombre',
    name_cant_be_empty: 'El nombre no puede estar vacío',
    rename_hint: 'Enter para guardar · Esc para cancelar',
    duplicate_name: 'Duplicar {name}',
    duplicate: 'Duplicar',
    rename_name: 'Renombrar {name}',
    rename: 'Renombrar',
    delete_name: 'Eliminar {name}',
    delete: 'Eliminar',
    templates: 'Plantillas',
    find_template_placeholder: 'Buscar plantilla…',
    find_template: 'Buscar plantilla',
    no_templates_match: 'Ninguna plantilla coincide con "{query}"',
    new_template: 'Nueva plantilla',
    pinned: 'Fijada',
    pinned_title: 'Variable fijada del sistema, siempre existe',
    auto: 'Auto',
    about_name: 'Acerca de {name}',
    edit_name_description: 'Editar descripción de {name}',
    edit_description: 'Editar descripción',
    unlock_name_value: 'Desbloquear valor de {name}',
    lock_name_value: 'Bloquear valor de {name}',
    unlock_variable: 'Desbloquear variable',
    lock_variable: 'Bloquear variable',
    enter_variable_description: 'Introduce la descripción de la variable',
    available_variables: 'Variables disponibles',
    current_value: 'Valor actual',
    no_variables_found: 'No se encontraron variables similares a "{query}"',
    error_badge: 'ERROR',
    template_and_basis: 'Plantilla y base de la factura',
    reset: 'Restablecer',
    unshare_template: 'Dejar de compartir la plantilla con el workspace',
    shared_click_to_unshare: 'Compartida con el workspace. Haz clic para dejar de compartir',
    save_and_share_confirm: '¿Guardar y compartir la plantilla con el workspace? Los miembros del workspace verán tu plantilla y variables (solo lectura).',
    share_confirm: '¿Compartir la plantilla con el workspace? Los miembros del workspace verán tu plantilla y variables (solo lectura).',
    share_template: 'Compartir plantilla con el workspace',
    share: 'Compartir',
    legacy_template_notice: 'Esta es una plantilla heredada. No se puede editar aquí, pero se puede descargar su HTML.',
    download_legacy_html: 'Descargar HTML heredado',
    template_variables: 'Variables de la plantilla',
    template_owner: 'Propietario de la plantilla',
    unknown_user: 'Usuario desconocido',
    current_marker: '(Actual)',
    save_and_generate: 'Guardar y generar',
    generate: 'Generar',
    delete_template_confirm: '¿Seguro que quieres eliminar esta plantilla?',
    unsaved_leave_message: '¿Guardar los cambios de esta plantilla antes de salir?',
    keep_editing: 'Seguir editando',
    untitled_template: 'Plantilla sin título',
    template_copy_name: '{name} (copia)',
  },
  salary: {
    salary_projects_breadcrumb: 'Proyectos salariales /',
    select_salary_project: 'Seleccionar proyecto salarial',
    generates_monthly_on_day: 'Se genera mensualmente el día {day}',
    generates_weekly_on_day: 'Se genera semanalmente el día {day}',
    recalculating_results: 'recalculando resultados..',
    create_salary_project: 'Crear proyecto salarial',
    edit_salary_project: 'Editar proyecto salarial',
    confirm_delete_project: '¿Seguro que quieres eliminar este proyecto salarial?',
    delete: 'Eliminar',
    no_projects_yet: 'Aún no hay proyectos salariales. Crea uno para empezar.',
    current_period_not_settled: 'Actual · {progress} · sin liquidar',
    day_progress: 'día {day} de {total}',
    members_count: '{n} miembro | {n} miembros',
    across_members: 'entre {n} miembro | entre {n} miembros',
    add_member: 'Añadir miembro',
    search_members: 'Buscar miembros',
    add_member_to_current_period: 'Añadir miembro al periodo actual',
    member: 'Miembro',
    user_vars: 'Variables de usuario',
    calculated: 'Calculado',
    export_column_csv: 'Exportar esta columna a CSV',
    confirm_remove_member: '¿Quitar a este miembro del periodo actual?',
    remove_member: 'Quitar miembro',
    summary: 'Resumen',
    columns_count: '{shown} de {total} columnas',
    metric_min: 'mín',
    metric_avg: 'prom',
    metric_max: 'máx',
    metric_median: 'mediana',
    metric_sum: 'suma',
    show_min: 'Mostrar mín',
    show_avg: 'Mostrar prom',
    show_max: 'Mostrar máx',
    show_median: 'Mostrar mediana',
    show_sum: 'Mostrar suma',
    select_project_from_list: 'Selecciona un proyecto salarial de la lista de arriba.',
    popup_subtitle: 'Los salarios se generan automáticamente según una programación.',
    project_name: 'Nombre del proyecto',
    project_name_placeholder: 'p. ej. Equipo de Kyiv',
    frequency: 'Frecuencia',
    week: 'Semana',
    month: 'Mes',
    day_of_month: 'Día del mes',
    day_of_week: 'Día de la semana',
    of_max_day: 'de {max}',
    timezone: 'Zona horaria',
    select_timezone: 'Seleccionar zona horaria',
    recreate_to_change_settings: '(si necesitas cambiar los ajustes de arriba, vuelve a crear el proyecto)',
    variables: 'Variables',
    add_variable: 'Añadir variable',
    no_variables_yet: 'Aún no hay variables. Añade valores por miembro, como el salario base o la tarifa por hora.',
    move_up: 'Subir',
    move_down: 'Bajar',
    create_project: 'Crear proyecto',
    average_salary: 'Salario medio',
    total_hours: 'Horas totales',
    predicted_salary: 'Salario previsto',
    actually_earned: 'Ganado realmente',
    own_hours: 'Horas propias',
    end_of_month_forecast: 'previsión a fin de mes',
    base_percent_hint: 'base {base} · {percent}% de la base',
    incl_base_in_eur: 'incl. salario base · en EUR',
    at_rate_per_hour: 'a {rate}/h',
    not_receiving_salary_yet: 'aún no recibes salario en este proyecto',
    var_desc_user_time_spent: 'Tiempo del usuario (horas) en el periodo; opcional: 3.er argumento = email, 4.º argumento = nombre del proyecto',
    var_desc_user_prediction_median: 'Mediana de USER_TIME_SPENT en los N periodos anteriores (horas); filtros opcionales de email/proyecto',
    var_desc_min: 'Devuelve el valor mínimo de dos argumentos numéricos',
    var_desc_previous_salary_point: 'Saldo del registro salarial anterior',
    var_desc_user_vars: 'Variable de usuario personalizada (reemplaza var_name por tu clave)',
    var_desc_exchange_rate: 'Tipo de cambio {alias}',
    var_desc_exchange_rate_month_start: 'Tipo del NBU el día 1 del mes del periodo (USD-UAH, EUR-UAH, PLN-UAH, CAD-UAH)',
    var_desc_previously_defined: 'Variable definida previamente',
    csv_copied: 'CSV copiado al portapapeles',
    csv_copy_failed: 'No se pudo copiar el CSV. Inténtalo de nuevo.',
  },
  tags: {
    burned_hours: 'Horas consumidas',
    planned: 'Planificadas',
    passed: 'Completadas',
    est_h: 'Est. h',
    tracked: 'Registrado',
    burned: 'Consumido',
    avg_velocity: 'Velocidad media',
    before_sprint: 'Antes del sprint',
    during_sprint: 'Durante el sprint',
    all_projects: 'Todos los proyectos',
    all_sprint_tasks: 'Todas las tareas del sprint',
    non_own_sprint_tasks: 'Tareas del sprint ajenas',
    non_this_project: 'Otros proyectos',
    effort_change: 'Cambio de esfuerzo',
    native_level: 'Nivel en el proyecto',
    altruist: 'Altruismo',
    sprint_start: 'Inicio del sprint',
    weekends_per_week: 'Días libres / semana',
    days_in_sprint: 'Días del sprint',
    show_velocity_stats: 'Mostrar estadísticas de velocidad',
    show_main_stats: 'Mostrar estadísticas principales',
    burndown: 'Burndown',
    remaining_vs_ideal_pace: 'Horas restantes vs. ritmo ideal',
    remaining: 'Restante',
    ideal: 'Ideal',
    remaining_hours: 'Horas restantes',
    ideal_burndown: 'Burndown ideal',
    tag_focus_hotkey: 'Enfoque de etiqueta (Alt+G)',
    tag_focus: 'Enfoque de etiqueta',
    unfocus: 'Quitar enfoque',
    filter_tags: 'Filtrar etiquetas...',
    show_eta: 'Mostrar ETA',
    calculate_eta: 'Calcular ETA',
    export_settings: 'Ajustes de exportación',
    include_executor: 'Incluir ejecutor',
    hours_in_story_point: 'Horas por story point',
    round_up_to: 'Redondear a',
    include_doing_hint: 'Si añadir la columna «doing» para que el cliente pueda activar/desactivar elementos con una casilla',
    include_doing: 'Incluir Doing',
    notdoing_tag: 'Etiqueta Notdoing',
    select_label: 'Seleccionar etiqueta',
  },
  pages: {
    access_denied_title: 'Lo sentimos',
    access_denied_subtitle: 'Algo salió mal y se cerró tu sesión en el espacio de trabajo activo.',
    access_denied_select_workspace: 'Selecciona un espacio de trabajo para continuar',
    access_denied_no_workspaces: 'Aún no tienes espacios de trabajo disponibles.',
    access_denied_create_new: 'Crear uno nuevo',
    access_denied_logged_in_as: 'Sesión iniciada como {email}',
    access_denied_login_another: 'Iniciar sesión con otra cuenta',
    ai_automation_other_client: 'Otro',
    app_download_not_uploaded: 'No subido',
    mcp_authorize_title: '¿Conectar {client}?',
    mcp_authorize_acts_on_behalf: '{client} ({host}) solicita actuar en tu nombre en el espacio de trabajo {workspace}: podrá ver y cambiar todo lo que tú puedes.',
    mcp_authorize_loopback_warning: 'Después de responder, tu navegador volverá a una aplicación que se ejecuta en este ordenador. Permítelo solo si acabas de empezar a conectar {client} tú mismo.',
    mcp_authorize_redirect_notice: 'Después de responder, tu navegador volverá a {host}.',
    mcp_authorize_deny: 'Denegar',
    mcp_authorize_allow: 'Permitir',
    mcp_authorize_invalid: 'Esta solicitud de autorización no es válida o ha caducado. Vuelve a iniciar la conexión desde tu cliente MCP.',
    project_no_projects_title: 'Aún no tienes proyectos 👀',
    project_no_projects_hint: 'Por favor, {create_project} en el menú superior izquierdo haciendo clic en {no_projects}',
    project_create_project: 'crea un proyecto',
    project_no_projects: 'Sin proyectos',
    project_settings_loading: 'Cargando...',
    integrations_add: 'Añadir integración',
    integrations_added_by: 'Añadido por {name} · {date}',
    integrations_unknown_user: 'Desconocido',
    integrations_close_config: 'Cerrar configuración',
    integrations_config: 'Configuración',
    integrations_delete_confirm: '¿Eliminar esta integración?',
    integrations_default_description: 'Integración de {name}',
    downtime_snooze_title: 'Posponer 10 minutos',
    task_notify_priority_title: 'Prioridad: {priority}',
    report_export_preparing: 'Preparando…',
  },
  ui: {
    ai_chat_empty: 'Pídeme que liste tus proyectos o que cree tareas.',
    ai_chat_error: 'Error: {error}',
    ai_chat_openai_auth_error: 'El asistente de IA no está disponible: la clave de la API de OpenAI no es válida o ha caducado.',
    ai_chat_something_went_wrong: 'Algo salió mal',
    checklist_progress_title: 'Progreso de la lista: {done} de {total} completados',
    close_button_title: 'Cerrar [ESC]',
    comment_integration: 'Integración',
    comment_unknown_user: 'Desconocido',
    common_header_create_task_title: 'Crear tarea [Alt+N]',
    create_task_error_reading_file: 'Error al leer el archivo. Inténtalo de nuevo.',
    download_mobile_back: 'Atrás',
    download_mobile_install_app: 'Instalar app',
    editor_sign_up_not_confirmed: 'Registro no confirmado',
    header_hidden_members: 'El proyecto tiene {count} miembros más:',
    hidden_screenshot_tooltip_in_project: 'No puedes ver esta captura porque no eres miembro del proyecto {projectName}',
    hidden_screenshot_tooltip_no_project: 'No puedes ver esta captura porque no eres miembro de este proyecto',
    hidden_task_tooltip_in_project: 'No puedes ver esta tarea porque no eres miembro del proyecto {projectName}',
    hidden_task_tooltip_no_project: 'No puedes ver esta tarea porque no eres miembro de este proyecto',
    integration_bot_name: 'Nombre',
    integration_bot_title: 'Bot',
    integration_param_readonly: 'solo lectura',
    pager_try_again_later: 'Inténtalo de nuevo más tarde',
    recording_controls_microphone_level: 'Nivel del micrófono',
    recording_controls_pause_title: 'Pausar la grabación de pantalla',
    recording_controls_resume_title: 'Reanudar la grabación de pantalla',
    recording_controls_stop_title: 'Detener la grabación de pantalla',
    searcher_no_tags: 'sin etiquetas',
    searcher_with_tag: 'Con etiqueta:',
    spinner_loading: 'Cargando...',
    stage_enter_new_name: 'El nombre de la etapa no puede estar vacío',
    stage_no_name: 'Etapa sin nombre',
    task_click_to_assign: 'Haz clic para asignar',
    task_dialog_comments_only: 'Solo comentarios',
    task_dialog_drop: 'Suelta aquí',
    task_dialog_logs_shown: 'Registros visibles',
    task_dialog_parent_task: 'Tarea principal',
    task_dialog_return_to_parent: 'Volver a la tarea principal',
    task_dialog_scroll_to_top: 'Ir arriba',
    task_dialog_subtasks: 'Subtareas',
    task_dialog_subtasks_caption: 'SUBTAREAS',
    task_dialog_toggle_rightbar: 'Detalles de la tarea',
    task_right_bar_add_subtask_title: 'Añadir subtarea [Alt+Ctrl+N]',
    user_avatar_executor_title: '{username} es el ejecutor de esta tarea',
  },
};
